/* eslint-disable @stylistic/brace-style */
import { optionsProxy } from '@vlabs/uikit';

import { i18nChartFormTranslation } from './i18n';

export const LISTS_GROUP_BY_VALUE = 'lists';

export const chartTypeOptions = optionsProxy.create([
  { get label() { return i18nChartFormTranslation('options.chart_type.age_distribution'); }, value: 'ageDistribution' },
  { get label() { return i18nChartFormTranslation('options.chart_type.gender_ratio'); }, value: 'genderRatio' },
  { get label() { return i18nChartFormTranslation('options.chart_type.attendance_by_gender'); }, value: 'attendanceByGender' },
  { get label() { return i18nChartFormTranslation('options.chart_type.gender_distribution'); }, value: 'genderDistribution' },
  { get label() { return i18nChartFormTranslation('options.chart_type.emotion_distribution'); }, value: 'emotionDistribution' },
  { get label() { return i18nChartFormTranslation('options.chart_type.average_age_by_gender'); }, value: 'averageAgeByGender' },
]);

export const DiagramTypes = {
  BAR: 'bar',
  HORIZONTAL_BAR: 'horizontalBar',
  AREA: 'area',
  STEP_AREA: 'stepArea',
  STACK: 'stack',
  LINE: 'line',
  PIE: 'pie',
  DOUGHNUT: 'doughnut',
  RADAR: 'radar',
} as const;

export const aggregatorOptions = optionsProxy.create([
  { get label() { return i18nChartFormTranslation('options.aggregator.count'); }, value: 'count' },
  { get label() { return i18nChartFormTranslation('options.aggregator.max'); }, value: 'max' },
  { get label() { return i18nChartFormTranslation('options.aggregator.min'); }, value: 'min' },
  { get label() { return i18nChartFormTranslation('options.aggregator.avg'); }, value: 'avg' },
]);

export const timeGroupingTypeOptions = optionsProxy.create([
  { get label() { return i18nChartFormTranslation('options.time_grouping.interval'); }, value: 'interval' },
  { get label() { return i18nChartFormTranslation('options.time_grouping.frequency'); }, value: 'frequency' },
]);

export const timeDimensionOptions = optionsProxy.create([
  { get label() { return i18nChartFormTranslation('options.time_dimension.minute'); }, value: 'm' },
  { get label() { return i18nChartFormTranslation('options.time_dimension.hour'); }, value: 'h' },
  { get label() { return i18nChartFormTranslation('options.time_dimension.day'); }, value: 'd' },
  { get label() { return i18nChartFormTranslation('options.time_dimension.week'); }, value: 'w' },
  { get label() { return i18nChartFormTranslation('options.time_dimension.month'); }, value: 'M' },
  { get label() { return i18nChartFormTranslation('options.time_dimension.year'); }, value: 'y' },
]);

export const frequencyOptions = optionsProxy.create([
  { get label() { return i18nChartFormTranslation('options.frequency.month_of_year'); }, value: 'monthOfYear' },
  { get label() { return i18nChartFormTranslation('options.frequency.week_of_year'); }, value: 'weekOfYear' },
  { get label() { return i18nChartFormTranslation('options.frequency.day_of_year'); }, value: 'dayOfYear' },
  { get label() { return i18nChartFormTranslation('options.frequency.day_of_month'); }, value: 'dayOfMonth' },
  { get label() { return i18nChartFormTranslation('options.frequency.day_of_week'); }, value: 'dayOfWeek' },
  { get label() { return i18nChartFormTranslation('options.frequency.hour_of_day'); }, value: 'hourOfDay' },
  { get label() { return i18nChartFormTranslation('options.frequency.minute_of_hour'); }, value: 'minuteOfHour' },
]);

export const filterFunctionOptions = optionsProxy.create([
  { get label() { return i18nChartFormTranslation('options.filter_function.like'); }, value: 'like' },
  { get label() { return i18nChartFormTranslation('options.filter_function.nlike'); }, value: 'nlike' },
  { get label() { return i18nChartFormTranslation('options.filter_function.in'); }, value: 'in' },
  { get label() { return i18nChartFormTranslation('options.filter_function.nin'); }, value: 'nin' },
  { get label() { return i18nChartFormTranslation('options.filter_function.eq'); }, value: 'eq' },
  { get label() { return i18nChartFormTranslation('options.filter_function.neq'); }, value: 'neq' },
  { get label() { return i18nChartFormTranslation('options.filter_function.gt'); }, value: 'gt' },
  { get label() { return i18nChartFormTranslation('options.filter_function.gte'); }, value: 'gte' },
  { get label() { return i18nChartFormTranslation('options.filter_function.lt'); }, value: 'lt' },
  { get label() { return i18nChartFormTranslation('options.filter_function.lte'); }, value: 'lte' },
  { get label() { return i18nChartFormTranslation('options.filter_function.covered'); }, value: 'covered' },
]);

export const filterFieldOptions = optionsProxy.create([
  { get label() { return i18nChartFormTranslation('options.filter_field.tags'); }, value: 'tags' },
  { get label() { return i18nChartFormTranslation('options.filter_field.source'); }, value: 'source' },
  { get label() { return i18nChartFormTranslation('options.filter_field.stream_id'); }, value: 'stream_id' },
  { get label() { return i18nChartFormTranslation('options.filter_field.user_data'); }, value: 'user_data' },
  { get label() { return i18nChartFormTranslation('options.filter_field.event_id'); }, value: 'event_id' },
  { get label() { return i18nChartFormTranslation('options.filter_field.external_id'); }, value: 'external_id' },
  { get label() { return i18nChartFormTranslation('options.filter_field.handler_id'); }, value: 'handler_id' },
  { get label() { return i18nChartFormTranslation('options.filter_field.top_similar_object_id'); }, value: 'top_similar_object_id' },
  { get label() { return i18nChartFormTranslation('options.filter_field.top_similar_external_id'); }, value: 'top_similar_external_id' },
  { get label() { return i18nChartFormTranslation('options.filter_field.top_matching_candidates_label'); }, value: 'top_matching_candidates_label' },
  { get label() { return i18nChartFormTranslation('options.filter_field.top_similar_object_similarity'); }, value: 'top_similar_object_similarity' },
  { get label() { return i18nChartFormTranslation('options.filter_field.face_id'); }, value: 'face_id' },
  { get label() { return i18nChartFormTranslation('options.filter_field.gender'); }, value: 'gender' },
  { get label() { return i18nChartFormTranslation('options.filter_field.age'); }, value: 'age' },
  { get label() { return i18nChartFormTranslation('options.filter_field.emotion'); }, value: 'emotion' },
  { get label() { return i18nChartFormTranslation('options.filter_field.mask'); }, value: 'mask' },
  { get label() { return i18nChartFormTranslation('options.filter_field.liveness'); }, value: 'liveness' },
  { get label() { return i18nChartFormTranslation('options.filter_field.deepfake'); }, value: 'deepfake' },
  { get label() { return i18nChartFormTranslation('options.filter_field.city'); }, value: 'city' },
  { get label() { return i18nChartFormTranslation('options.filter_field.area'); }, value: 'area' },
  { get label() { return i18nChartFormTranslation('options.filter_field.district'); }, value: 'district' },
  { get label() { return i18nChartFormTranslation('options.filter_field.street'); }, value: 'street' },
  { get label() { return i18nChartFormTranslation('options.filter_field.house_number'); }, value: 'house_number' },
  { get label() { return i18nChartFormTranslation('options.filter_field.geo_position'); }, value: 'geo_position' },
  { get label() { return i18nChartFormTranslation('options.filter_field.track_id'); }, value: 'track_id' },
  { get label() { return i18nChartFormTranslation('options.filter_field.apparent_age'); }, value: 'apparent_age' },
  { get label() { return i18nChartFormTranslation('options.filter_field.apparent_gender'); }, value: 'apparent_gender' },
  { get label() { return i18nChartFormTranslation('options.filter_field.sleeve_length'); }, value: 'sleeve_length' },
  { get label() { return i18nChartFormTranslation('options.filter_field.headwear_state'); }, value: 'headwear_state' },
  { get label() { return i18nChartFormTranslation('options.filter_field.headwear_apparent_color'); }, value: 'headwear_apparent_color' },
  { get label() { return i18nChartFormTranslation('options.filter_field.upper_clothing_colors'); }, value: 'upper_clothing_colors' },
  { get label() { return i18nChartFormTranslation('options.filter_field.lower_garment_colors'); }, value: 'lower_garment_colors' },
  { get label() { return i18nChartFormTranslation('options.filter_field.lower_garment_type'); }, value: 'lower_garment_type' },
  { get label() { return i18nChartFormTranslation('options.filter_field.shoes_apparent_color'); }, value: 'shoes_apparent_color' },
  { get label() { return i18nChartFormTranslation('options.filter_field.backpack_state'); }, value: 'backpack_state' },
  { get label() { return i18nChartFormTranslation('options.filter_field.meta'); }, value: 'meta' },
  { get label() { return i18nChartFormTranslation('options.filter_field.lists'); }, value: 'lists' },
]);

export const targetOptions = optionsProxy.create([
  ...filterFieldOptions.raw,
  { get label() { return i18nChartFormTranslation('options.filter_field.create_time'); }, value: 'create_time' },
  { get label() { return i18nChartFormTranslation('options.filter_field.end_time'); }, value: 'end_time' },
]);

const withoutGroupBy = [
  'top_similar_object_similarity',
  'create_time',
  'end_time',
  'tags',
  'geo_position',
  'upper_clothing_colors',
  'lower_garment_colors',
  'meta',
];

export const targetForGroupByAggregatorOptions = optionsProxy.create(
  targetOptions.raw.filter((option) => !withoutGroupBy.includes(option.value)),
);
